import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { ActionMenuItem } from './ActionMenuItem';

export const AlsActions = ({ activity }: ActivityActionsProps) => {
  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');

  return (
    <>
      <NavLink to={'/als/' + activitykeyUrlEncoded}>
        <ActionMenuItem icon={'view'} title={'View'} />
      </NavLink>
    </>
  );
};
